import { z } from 'zod';
import { ResponseStatus } from 'domains/models/event/responseStatus';
import { SourceType } from 'domains/models/event_source/sourceType';
import { Status } from 'domains/models/event/status';
import { DisplayType } from 'domains/models/event_type/displayType';
import {
  Transparency,
  TransparencyText,
} from 'domains/models/event/transparency';
import { ReservationMethod } from 'domains/models/event_type/reservationMethod';
import { Priority, PriorityText } from 'domains/models/event/priority';
import { Label } from 'domains/models/event/label';
import { Behavior, BehaviorText } from 'domains/models/event/behavior';
import { DisplayTypeText } from 'domains/models/event/displayType';
import {
  VisibilityType,
  VisibilityTypeText,
} from 'domains/models/event/visibilityType';
import { ProviderType } from 'domains/models/calendar/providerType';

export const ResponseStatusEnum = z.nativeEnum(ResponseStatus);
export const StatusEnum = z.nativeEnum(Status);
export const TransparencyEnum = z.nativeEnum(Transparency);
export const BehaviorEnum = z.nativeEnum(Behavior);
export const VisibilityTypeEnum = z.nativeEnum(VisibilityType);
export const DisplayTypeEnum = z.nativeEnum(DisplayType);
export const PriorityEnum = z.nativeEnum(Priority);
export const SourceTypeEnum = z.nativeEnum(SourceType);
export const LabelEnum = z.nativeEnum(Label);
export const ReservationMethodEnum = z.nativeEnum(ReservationMethod);
export const ProviderTypeEnum = z.nativeEnum(ProviderType);
export const TransparencyTextEnum = z.nativeEnum(TransparencyText);
export const BehaviorTextEnum = z.nativeEnum(BehaviorText);
export const VisibilityTypeTextEnum = z.nativeEnum(VisibilityTypeText);
export const DisplayTypeTextEnum = z.nativeEnum(DisplayTypeText);
export const PriorityTextEnum = z.nativeEnum(PriorityText);
